import React from "react";
import { Checkbox } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { HelpTooltip } from "./inputs/HelpTooltip";
import { useHelpTooltip } from "../hooks/useHelpTooltip";
import { getStatusTranslation } from "../utils/getStatusTranslation";
import { getPersonFilterStatuses } from "../utils/personFilterStatuses";
import styles from "./PersonStatusFilterOptions.module.css";
// One status checkbox; a status with a "ui-br-agency.status.<STATUS>.help" translation gets the
// same info tooltip the form inputs use, placed next to (not inside) the checkbox label.
var PersonStatusFilterOption = function (_a) {
    var status = _a.status, checked = _a.checked, onChange = _a.onChange;
    var intl = useIntl();
    var _b = useHelpTooltip("ui-br-agency.status.".concat(status)), helpId = _b.helpId, hasHelp = _b.hasHelp;
    return (React.createElement("div", { className: styles.option },
        React.createElement(Checkbox, { label: getStatusTranslation(intl, status), checked: checked, onChange: onChange }),
        hasHelp && (React.createElement(HelpTooltip, { id: "person-status-filter-".concat(status, "-help"), textId: helpId, hasLabel: false }))));
};
// Status checkboxes shared by the natural and legal person register filters.
export var PersonStatusFilterOptions = function (_a) {
    var selected = _a.selected, canSeeSearchFailed = _a.canSeeSearchFailed, onStatusChange = _a.onStatusChange;
    return (React.createElement(React.Fragment, null, getPersonFilterStatuses(canSeeSearchFailed).map(function (status) { return (React.createElement(PersonStatusFilterOption, { key: status, status: status, checked: selected.includes(status), onChange: function () { return onStatusChange(status); } })); })));
};
